import { render, staticRenderFns } from "./StatusData.vue?vue&type=template&id=14389b96&scoped=true&"
import script from "./StatusData.vue?vue&type=script&lang=js&"
export * from "./StatusData.vue?vue&type=script&lang=js&"
import style0 from "./StatusData.vue?vue&type=style&index=0&id=14389b96&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14389b96",
  null
  
)

export default component.exports